<template lang="pug">
    div
        .title Monto:
        v-text-field.title#transbank-pay-input(
            ref="amountInput"
            :mask="mixCurrencyMask(customerCreditPayment, 12)"
            prefix="$"
            v-model="customerCreditPayment"
            @keyup.enter="handleEnter()"
            readonly)
        v-divider
        .title Plazo a pagar:
        v-select.title#select-instalment(label="Seleccione plazo a pagar"
            ref="dateInput"
            :items="instalmentList"
            item-text="text"
            item-value="id"
            v-model="instalment"
            @keyup.enter="handleEnter()"
            @input="setCustomerCretidPaymentDetail")
</template>

<script>
// Mixins:
import CurrencyUtils from '@/mixins/CurrencyUtils'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'customer-credit-payment',
    props: {},
    data: function() {
        return {
            voucher: '',
            customerCreditPayment: '',
            /*
            instalmentList: [
                { id: 4, text: 'Contra Entrega' },
                { id: 5, text: '5 días' },
                { id: 6, text: '7 días' },
                { id: 7, text: '10 días' },
                { id: 0, text: '15 días' },
                { id: 1, text: '30 días' },
            ],
            */
            instalment: '',
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            paymentMethod: 'paymentMethod',
            total: state => state.total,
        }),
        //...mapState('SessionModule', ['']),

        ...mapGetters('CashDeskModule', {
            totalToPay: 'totalToPay',
        }),
        ...mapGetters('SessionModule', ['customerPaymentOptions']),
        instalmentList() {
            return this.customerPaymentOptions.map(({ id, type }) => ({
                id,
                text: type,
            }))
        },
    },

    methods: {
        ...mapActions('CashDeskModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
        }),

        setCustomerCretidPaymentDetail() {
            let payload = this.obtainInstalment(this.instalment)
            this.setPaymentDetail(payload)
        },

        obtainInstalment(id) {
            for (let i = 0; i < this.instalmentList.length; i++) {
                if (this.instalmentList[i].id === id) {
                    return {
                        id: this.instalmentList[i].id,
                        text: this.instalmentList[i].text,
                    }
                }
            }
            return null
        },

        handleEnter() {
            if (!this.customerCreditPayment) {
                this.$nextTick(() => this.$refs.amountInput.focus())
                return
            } else if (!this.instalment) {
                this.$nextTick(() => this.$refs.dateInput.focus())
                return
            } else if (this.customerCreditPayment && this.instalment) {
                this.$emit('confirm')
            }
        },
    },
    watch: {},
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        this.customerCreditPayment = this.totalToPay.toString()
        this.setPayment(this.customerCreditPayment)
        this.$nextTick(() =>
            document.getElementById('select-instalment').focus()
        )
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
